import axios from "axios";

const get_token = () => {
    const token = document.querySelector('[name=csrf-token]').content;
    return axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
}

const StudyEstEukTechMapCommissionApiService = {
    async update(commission_status) {
        get_token();
        try {
            return await axios.put(
                '/study/study_est_euk_commission_statuses/:id',
                { commission_status }
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async show(params) {
        get_token();
        try {
            return await axios.get(
                '/study/study_est_euk_commission_statuses/:id',
                { params }
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async delete(params) {
        get_token();
        try {
            return await axios.delete(
                '/study/study_est_euk_commission_statuses/:id',
                { params }
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async get_link(id) {
        get_token();
        try {
            return await axios.get(
                `/study/auth_inspector_tm?w_url=https://newmoodle.amursu.ru/course/view.php?id=${id}`
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
}

export default StudyEstEukTechMapCommissionApiService;